import { render } from "./DialogUploadBlacklistExcel.vue?vue&type=template&id=12127615"
import script from "./DialogUploadBlacklistExcel.vue?vue&type=script&lang=js"
export * from "./DialogUploadBlacklistExcel.vue?vue&type=script&lang=js"

import "./DialogUploadBlacklistExcel.vue?vue&type=style&index=0&id=12127615&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__